import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useEmployer } from "../../../../../data/employer";
import { useUser, useUserByEmail } from "../../../../../data/user";
import { useInvitation } from "../../../../../data/invitation";
import EmployerOnboardingIndex from "./EmployerInvitationForm";
import InstantTeamsSpinner from "../../../../../components/custom-ui/animations/spinner/InstantTeamsSpinner";

const InvalidInvitation = () => {
  return (
    <>
      <div className="mt-1 text-lg font-bold ">
        This invitation is no longer valid.{" "}
      </div>
      <div>
        Please reach out to your Instant Teams point of contact for next steps.
      </div>
    </>
  );
};

const ProcessingInvitation = () => {
  return (
    <>
      <div className="mt-1 text-lg font-bold ">
        Please stand by while we process your invitation...{" "}
      </div>
      <div>
        <InstantTeamsSpinner />
      </div>
    </>
  );
};

function AcceptNewInvitation() {
  const params = useParams();
  const navigate = useNavigate();

  const [processingInvitation, setProcessingInvitation] = useState(false);

  const {
    data: invitation,
    status: invitationStatus,
    error: invitationsError,
  } = useInvitation(params.invitationId ?? "");

  const { status, employerId, invitedBy, email: userEmail } = invitation ?? {};

  // 'sent' is the only status that should allow registration to continue
  const isInviteValid = status === "sent";

  const {
    data: employer,
    status: employerQueryStatus,
    error: employerQueryError,
  } = useEmployer(employerId);

  const { displayName, contact = {} } = employer ?? {};

  // get the information about user that created invitation for use in welcome message
  const {
    data: invitedByInfo,
    status: invitedByInfoQueryStatus,
    error: invitedByInfoQueryError,
  } = useUser(invitedBy);

  // const {
  //   data: generalUser,
  //   status: generalUserStatus,
  //   error: generalUserError,
  // } = useUserByEmail(userEmail);

  const { name: invitedByName, email: invitedByEmail } = invitedByInfo ?? {};

  const handleDone = () => {
    // navigate("/registration/multifactor-enrollment");
    navigate("/home");
  };

  return (
    <section
    // className="mt-20 px-4"
    >
      {invitationStatus !== "loading" && (
        <>
          <div
          // className="container mx-auto max-w-sm"
          >
            {invitation ? (
              // !isInviteValid && (
              // status === "sent" && (
                // !processingInvitation &&
                <>
                  <EmployerOnboardingIndex
                    invitation={invitation}
                    onDone={handleDone}
                    processingInvitation={setProcessingInvitation}
                  />
                </>
              // )
            ) : (
              <>
                {/* <EmployerOnboardingIndex
                  invitation={invitation}
                  onDone={handleDone}
                  processingInvitation={setProcessingInvitation}
                /> */}
              </>
            )}
            {/* Recently registered and waiting on app to navigate */}
            {/* {invitation && processingInvitation && <ProcessingInvitation />} */}

            {/* any existing invitation with a status other than "sent" */}
            {/* {invitation && status !== "sent" && (
              // !processingInvitation &&
              <InvalidInvitation />
            )} */}

            {/* If no invitation is returned  */}
            {/* {invitation == null && <InvalidInvitation />} */}
          </div>
        </>
      )}
    </section>
  );
}

export default AcceptNewInvitation;
